import { equals } from 'ramda';
import { sanitize } from './forms';

export const getMerchantCapabilityPayload = (
  mid,
  { initialState = null, ...state },
  getBodyCallback,
  container,
) => {
  const headers = container ? { 'X-PRODUCTS-CONTAINER': container } : {};
  const body = sanitize(getBodyCallback(state));
  const initialBody = initialState === null ? null : getBodyCallback(initialState);
  const payload = { headers, params: { mid }, body };
  const hasChanged = initialBody === null || !equals(initialBody, body);

  return { payload, hasChanged };
};

export const getBpcCapabilityPayload = (
  contractKrn,
  { initialState = null, ...state },
  getBodyCallback,
  container,
) => {
  const headers = container ? { 'X-PRODUCTS-CONTAINER': container } : {};
  const body = sanitize(getBodyCallback(state));
  const initialBody = initialState === null ? null : getBodyCallback(initialState);
  const payload = { headers, params: { contractKrn }, body };
  const hasChanged = initialBody === null || !equals(initialBody, body);

  return { payload, hasChanged };
};
